import styled from 'styled-components';

export const StyledTooltipWithIcon = styled.span`
  margin-left: 6px;
  cursor: help;
  display: inline-flex;

  .anticon {
    color: ${(props) => props.theme.manslauksZils};
    font-size: 14px;
  }
`;
